"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SLA_TIMER_TEST_ID = exports.LTT_TIMER_TEST_ID = void 0;
var SLA_TIMER_TEST_ID = exports.SLA_TIMER_TEST_ID = 'crm_sla_timer';
var LTT_TIMER_TEST_ID = exports.LTT_TIMER_TEST_ID = 'crm_ltt_timer';